import { isSubmissionData2026 } from "../../../reduxToolkit/submissionsSlice";
import { RequireSubmissionProvided } from "../../../wrappers/requireSubmission";
import { SubmitToSedera2026 } from "./submitToSedera/2026/submitToSedera2026";

interface SubmitToSederaProps extends RequireSubmissionProvided {
}

export function SubmitToSedera({ submission }: SubmitToSederaProps) {
  const data = submission.data
  if (data) {
    if (isSubmissionData2026(data)) {
      return <SubmitToSedera2026 submission={submission} />
    }

    throw new Error(`Unknown submission data: ${JSON.stringify(data)}`)
  }

  return <SubmitToSedera2026 submission={submission} />
}
